import Dialog from "@stimulus-components/dialog";

export default class extends Dialog {
  connect() {
    super.connect()
  }
  // static targets = ["dialog"];
  backdropClose(event) {
    //   if (this.hasDialogTarget && event.target === this.dialogTarget) {
    //     this.close();
    //     this.dispatch("backdropClose");
    //   }
  }
}
